import { Reducer } from 'redux'
import { CouponState, CouponActionTypes } from './type'

const initialState: CouponState = {
  inquiryCoupon: [],
  drugCoupon: [],
  extendedCoupons: [],
  servicePackageCoupons: [],
  serviceProductCoupons: [],
  couponing: {}
}

const reducer: Reducer<CouponState> = (state = initialState, action) => {
  switch (action.type) {
    case CouponActionTypes.FETCH_COUPON_LIST_SUCCESS: {
      const { inquiryCoupon, drugCoupon, extendedCoupons, servicePackageCoupons, serviceProductCoupons } = action;
      return {
        ...state,
        inquiryCoupon,
        drugCoupon,
        extendedCoupons,
        servicePackageCoupons,
        serviceProductCoupons
      }
    }
    case CouponActionTypes.USE_COUPON: {
      const { data } = action;
      return {
        ...state,
        couponing: data
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as CouponReducer };
